import { useEffect } from 'react';
import { useDeviceDetection } from '@/hooks/use-mobile';

/**
 * Runtime mobile tweaks that must never block native scrolling.
 */
export const MobileOptimizations = () => {
  const { isMobile, isIOS, isAndroid, isStandalone } = useDeviceDetection();

  useEffect(() => {
    const shouldApply = isAndroid || isMobile;
    if (!shouldApply) return;

    console.log('📱 [Mobile] Applying safe scroll optimizations', {
      isIOS,
      isAndroid,
      isStandalone,
    });

    const style = document.createElement('style');
    style.setAttribute('data-mobile-scroll-fix', 'true');
    style.textContent = `
      html, body, #root {
        overflow-y: auto !important;
        height: auto !important;
      }

      body {
        overscroll-behavior-y: auto !important;
        touch-action: pan-y pinch-zoom;
      }

      html, body, #root {
        overflow-x: hidden !important;
        max-width: 100vw !important;
        width: 100% !important;
        box-sizing: border-box !important;
      }

      input, textarea, select, button {
        font-size: 16px !important;
      }
    `;

    document.head.appendChild(style);

    return () => {
      if (style.parentNode) {
        style.parentNode.removeChild(style);
      }
    };
  }, [isMobile, isIOS, isAndroid, isStandalone]);

  return null;
};
